import { createFocusTrap as e } from "focus-trap";
import { p as t, b as u } from "./dom.js";
import { f as o } from "./runtime.js";
/*! All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
v3.0.3 */
function n(a, c) {
  const { el: s } = a, r = c?.focusTrapEl || s;
  r && (a.focusTrap = e(r, f(s, c?.focusTrapOptions)));
}
function f(a, c) {
  return {
    clickOutsideDeactivates: !0,
    fallbackFocus: c?.fallbackFocus || a,
    setReturnFocus: (r) => (u(r), !1),
    ...c,
    // the following options are not overridable
    document: a.ownerDocument,
    tabbableOptions: t,
    trapStack: o
  };
}
function d(a, c) {
  (a.focusTrapDisabledOverride ? !a.focusTrapDisabledOverride() : !a.focusTrapDisabled) && a.focusTrap?.activate(c);
}
function l(a, c) {
  a.focusTrap?.deactivate(c);
}
export {
  d as a,
  n as b,
  f as c,
  l as d
};
